/**
 * @generated SignedSource<<31776782a75ea4964247bf74e804fb82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useSavedFiltersQuery$variables = {};
export type useSavedFiltersQuery$data = {
  readonly viewer: {
    readonly savedFilters: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly criteria: string | null;
    }>;
  } | null;
};
export type useSavedFiltersQuery = {
  variables: useSavedFiltersQuery$variables;
  response: useSavedFiltersQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "SavedFilter",
  "kind": "LinkedField",
  "name": "savedFilters",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "criteria",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSavedFiltersQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useSavedFiltersQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a4ce79dd613535ebecff43de00df4935",
    "id": null,
    "metadata": {},
    "name": "useSavedFiltersQuery",
    "operationKind": "query",
    "text": "query useSavedFiltersQuery {\n  viewer {\n    savedFilters {\n      id\n      name\n      criteria\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0e3f3261f89ef5a50f62a4798512236";

export default node;
